import { render, staticRenderFns } from "./Enteringpayments.vue?vue&type=template&id=e50b4ee4&"
import script from "./Enteringpayments.vue?vue&type=script&lang=js&"
export * from "./Enteringpayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports